import React from 'react';
import { Check } from 'lucide-react';
import { useSimulateur } from './SimulateurContext';

const steps = [
  { id: 1, label: 'Transaction' },
  { id: 2, label: 'Type de bien' },
  { id: 3, label: 'Détails' },
  { id: 4, label: 'Diagnostics' },
  { id: 5, label: 'Coordonnées' },
  { id: 6, label: 'Récapitulatif' },
];

export const StepIndicator = () => {
  const { currentStep, goToStep } = useSimulateur();

  return (
    <div className="w-full py-6">
      {/* Mobile: Simple progress bar */}
      <div className="md:hidden">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-emerald-700">
            Étape {currentStep} sur {steps.length}
          </span>
          <span className="text-sm text-stone-500">
            {steps[currentStep - 1]?.label}
          </span>
        </div>
        <div className="w-full bg-stone-200 rounded-full h-2">
          <div 
            className="bg-gradient-to-r from-emerald-500 to-emerald-600 h-2 rounded-full transition-all duration-500 ease-out"
            style={{ width: `${(currentStep / steps.length) * 100}%` }}
          />
        </div>
      </div>

      {/* Desktop: Step circles */}
      <div className="hidden md:block">
        <div className="flex items-center justify-between relative">
          {/* Progress line background */}
          <div className="absolute top-5 left-0 right-0 h-0.5 bg-stone-200" />
          
          {/* Progress line fill */}
          <div 
            className="absolute top-5 left-0 h-0.5 bg-gradient-to-r from-emerald-500 to-emerald-600 transition-all duration-500 ease-out"
            style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
          />

          {steps.map((step, index) => {
            const isCompleted = currentStep > step.id;
            const isCurrent = currentStep === step.id;
            const isClickable = step.id < currentStep;

            return (
              <div 
                key={step.id} 
                className="flex flex-col items-center relative z-10"
              >
                <button
                  onClick={() => isClickable && goToStep(step.id)}
                  disabled={!isClickable}
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center 
                    font-semibold text-sm transition-all duration-300
                    ${isCompleted 
                      ? 'bg-emerald-600 text-white cursor-pointer hover:bg-emerald-700' 
                      : isCurrent 
                        ? 'bg-emerald-600 text-white ring-4 ring-emerald-100' 
                        : 'bg-stone-200 text-stone-500 cursor-not-allowed'
                    }
                  `}
                  data-testid={`step-indicator-${step.id}`}
                >
                  {isCompleted ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    step.id
                  )}
                </button>
                <span 
                  className={`
                    mt-2 text-xs font-medium transition-colors duration-300
                    ${isCurrent ? 'text-emerald-700' : isCompleted ? 'text-emerald-600' : 'text-stone-400'}
                  `}
                >
                  {step.label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
